export default {
  title: "Tittel",
  artists: "Artister",
  platforms: "Platformer",
  published: "Publisert",
  menu: {
    tooltip: "Alle låter"
  }
}



// WEBPACK FOOTER //
// ./src/locales/no/component/module/artist/misc/TrackStripLabels.js